import { render, staticRenderFns } from "./Lore.vue?vue&type=template&id=f0840582"
import script from "./Lore.vue?vue&type=script&lang=js"
export * from "./Lore.vue?vue&type=script&lang=js"
import style0 from "./Lore.vue?vue&type=style&index=0&id=f0840582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4_46dc5111b415f48666a4cba00a7cab33/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports